import React, { useEffect, useState } from "react";
import { makeStyles, createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import HeaderRegister from "../../components/HeaderRegister";
import clsx from "clsx";
import { Grid, FormControl, InputLabel, OutlinedInput, Typography, IconButton, InputAdornment, FormControlLabel, Radio, Card, CardContent, Button, Drawer, CircularProgress, TextField } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { FormattedMessage, useIntl } from "react-intl";
import { SERVER_URL } from "../../config/backend";
import ModalNacionalidad from "../../components/ModalNacionalidad";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ModalMensajes from "../../components/ModalMensajes";

const useStyles = makeStyles((theme) => ({
    gridItem: {
        padding: "0px",
        margin: "0px",
    },
    paperContainer: {
        height: "auto",
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
    },
    imageSize2160: {
        backgroundImage: `url(${require("../../static/Imágenes/Registro/Background._Registro.webp")})`,
    },
    FormControl: {
        marginTop: "2rem",
        width: "70%",
        //textAlign:'right'
    },
    itemsFormControlRight: {
        textAlign: "right",
    },
    itemsFormControlLeft: {
        textAlign: "left",
    },
    select: {
        width: "70%",
    },
    inputLabel: {
        color: theme.palette.secondary.light,
    },
    colorText: {
        color: theme.palette.primary.contrastText,
        fontStyle: "italic",
        fontSize: "16px",
    },
    buttonRegistrarse: {
        backgroundColor: theme.palette.secondary.light,
        "&:hover": {
            //backgroundColor: theme.palette.secondary.main
            backgroundColor: theme.palette.secondary.light,
        },
    },
    drawerPaper: {
        background: "#F3F3F3",
        width: window.screen.width > 600 ? 600 : window.screen.width,
    },
    drawer: {
        flexShrink: 0,
    },
    modalContent: {
        backgroundColor: theme.palette.primary.main,
    },
    modalActions: {
        backgroundColor: theme.palette.primary.main,
        textAlign: "center",
    },
    textoError: {
        color: theme.palette.secondary.dark,
        fontWeight: "bold",
        fontSize: "14pt",
    },
    texto: {
        color: theme.palette.secondary.dark,
    },
    button: {
        backgroundColor: theme.palette.secondary.dark,
        borderRadius: 8,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            borderRadius: 8,
        },
    },
    botonTexto: {
        color: "#A68A30",
        "&:hover": {
            cursor: "pointer",
        },
    },
}));

const theme = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: 8,
                height: 50,
                color: "#929292",
                "&:hover $notchedOutline": {
                    borderColor: "#929292",
                    border: "2px solid",
                },
                // Focused state
                "&$focused $notchedOutline": {
                    borderColor: "#A68A30",
                    border: "2px solid",
                },
            },
        },
        MuiInputLabel: {
            root: {
                color: "#929292",
            },
        },
    },
    palette: {
        primary: {
            main: "#182C20",
            dark: "#262626",
            light: "#565656",
            contrastText: "#929292",
        },
        secondary: {
            main: "#F7D00E",
            dark: "#A68A30",
            light: "#DFDFDF",
            contrastText: "#F3F3F3",
        },
    },
});

export default function Register(params) {
    const classes = useStyles();
    const intl = useIntl();
    const selector = useSelector((store) => store);
    const globalLang = useSelector((store) => (store.user.lang === undefined ? "es" : store.user.lang));
    const dispatch = useDispatch();
    const history = useHistory();
    var imageSize = classes.imageSize2160;

    //-------------------------------------------------------------------------------
    //----------------------------ESTADOS--------------------------------------------
    //-------------------------------------------------------------------------------
    const [nombres, setNombres] = useState("");
    const [correo, setCorreo] = useState("");
    const [nacionalidad, setNacionalidad] = useState("");
    const [nacionalidadId, setNacionalidadId] = useState("");
    const [movil, setMovil] = useState("");
    const [contrasenna, setContrasenna] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [confirmarContrasenna, setConfirmarContrasenna] = useState("");
    const [boletin, setBoletin] = useState(false);
    const [listadoNacionalidades, setListadoNacionalidades] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openModalMensajes, setOpenModalMensajes] = useState(false);
    const [cuerpoModalMensajes, setCuerpoModalMensajes] = useState({
        tituloModal: "informacion",
        textoModal: "",
    });

    var countries = `query Countries($skip: Int!,$take:Int,$report:Boolean){
                        countries(skip:$skip,take:$take,report:$report){
                            status,
                            objects{
                                id,name,nationality,isActive,flag
                            }
                        }
                    }`;

    //-------------------------------------------------------------------------------
    //----------------------------FUNCIONES------------------------------------------
    //-------------------------------------------------------------------------------

    const callApiCountries = async () => {
        await fetch(`${SERVER_URL}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
                language: globalLang,
            },
            body: JSON.stringify({
                operationName: "Countries",
                query: countries,
                variables: {
                    skip: 1,
                    take: 20,
                    report: true,
                },
            }),
        })
            .then((r) => r.json())
            .then((data) => {
                if (data["data"]["countries"]["status"] === 200) {
                    var nacionalidades = data["data"]["countries"]["objects"];
                    let arr = [];
                    for (var n in nacionalidades) {
                        let obj = [];
                        obj["id"] = nacionalidades[n]["id"];
                        obj["name"] = nacionalidades[n]["name"];
                        obj["nationality"] = nacionalidades[n]["nationality"];
                        obj["isActive"] = nacionalidades[n]["isActive"];
                        arr.push(obj);
                    }
                    setListadoNacionalidades(arr);
                }
            });
    };

    const getNacionalidad = (id) => {
        let nacionalidad = "";
        for (let index = 0; index < listadoNacionalidades.length; index++) {
            if (listadoNacionalidades[index].id === id) {
                nacionalidad = listadoNacionalidades[index].nationality;
            }
        }
        return nacionalidad;
    };

    const onChangeNombre = (e) => {
        setNombres(e.target.value);
    };

    const onChangeCorreo = (e) => {
        setCorreo(e.target.value);
    };

    const onChangeNacionalidad = (e) => {
        // setNacionalidad(e.target.value);
    };

    const onChangeMovil = (e) => {
        setMovil(e.target.value);
    };

    const onChangeContrasenna = (e) => {
        setContrasenna(e.target.value);
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const onChangeConfirmarContrasenna = (e) => {
        setConfirmarContrasenna(e.target.value);
    };

    const onClicRecibirBoletin = () => {
        setBoletin(!boletin);
    };

    const onClickRegistrarse = async () => {
        let regexNombreApellidos = /^([A-Za-zÁÉÍÓÚñáéíóúÑ]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ']+[\s])+([A-Za-zÁÉÍÓÚñáéíóúÑ]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ'])+[\s]?([A-Za-zÁÉÍÓÚñáéíóúÑ]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ'])?$/;
        let regexEmail = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
        let regexTelefono = /^[+]?[0-9]{8,20}$/;
        let regexPasswordNumeros = /\d/g;
        let regexPasswordMayuscula = /[A-Z]/g;
        let regexPasswordMinuscula = /[a-z]/g;

        let firstName = "";
        let lastName = "";
        let fecha = new Date();
        // let date = fecha.getFullYear() + "" + fecha.getMonth() + "" + fecha.getDate() + "" + fecha.getMilliseconds();
        let date = `${fecha.getFullYear()}${fecha.getMonth()}${fecha.getDate()}${fecha.getMilliseconds()}`;
        if (!regexNombreApellidos.test(nombres)) {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_registrarse_uno" />,
            });
            setOpenModalMensajes(true);
            return;
        } else {
            let arrName = nombres.split(" ");
            if (arrName.length === 4) {
                firstName = arrName[0] + " " + arrName[1];
                lastName = arrName[2] + " " + arrName[3];
            } else if (arrName.length === 3) {
                firstName = arrName[0];
                lastName = arrName[1] + " " + arrName[2];
            } else if (arrName.length === 2) {
                firstName = arrName[0];
                lastName = arrName[1];
            } else {
                setCuerpoModalMensajes({
                    ...cuerpoModalMensajes,
                    tituloModal: "informacion",
                    textoModal: <FormattedMessage id="validacion_registrarse_dos" />,
                });
                setOpenModalMensajes(true);
                return;
            }
        }
        if (nacionalidad === "") {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_registrarse_tres" />,
            });
            setOpenModalMensajes(true);
            return;
        }
        if (movil !== "") {
            if (!regexTelefono.test(movil)) {
                setCuerpoModalMensajes({
                    ...cuerpoModalMensajes,
                    tituloModal: "informacion",
                    textoModal: <FormattedMessage id="validacion_registrarse_diez" />,
                });
                setOpenModalMensajes(true);
                return;
            }
        }
        if (!regexEmail.test(correo)) {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_registrarse_cuatro" />,
            });
            setOpenModalMensajes(true);
            return;
        }
        if (contrasenna.length < 7 || !regexPasswordNumeros.test(contrasenna) || !regexPasswordMayuscula.test(contrasenna) || !regexPasswordMinuscula.test(contrasenna)) {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_registrarse_cinco" />,
            });
            setOpenModalMensajes(true);
            return;
        }
        if (contrasenna !== "" && confirmarContrasenna !== "") {
            if (contrasenna !== confirmarContrasenna) {
                setCuerpoModalMensajes({
                    ...cuerpoModalMensajes,
                    tituloModal: "informacion",
                    textoModal: <FormattedMessage id="validacion_registrarse_seis" />,
                });
                setOpenModalMensajes(true);
                return;
            }
        }
        if (contrasenna === "") {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_registrarse_siete" />,
            });
            setOpenModalMensajes(true);
            return;
        }
        if (confirmarContrasenna === "") {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_registrarse_ocho" />,
            });
            setOpenModalMensajes(true);
            return;
        }
        var register = `
            mutation Register($input:SignupInput!){
                signup(input:$input){
                    status,
                    errors{
                        field,
                        messages
                    }
                }
            }`;
        setLoading(true);
        await fetch(`${SERVER_URL}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            },
            body: JSON.stringify({
                operationName: "Register",
                query: register,
                variables: {
                    input: {
                        firstName: firstName,
                        lastName: lastName,
                        email: correo,
                        countryId: nacionalidadId.toString(),
                        identity: date.toString(),
                        phone: movil.toString(),
                        password: contrasenna,
                        subscribeNewsLetter: boletin,
                    },
                },
            }),
        })
            .then((r) => r.json())
            .then((data) => {
                if (data["data"]["signup"]["status"] !== 200) {
                    setLoading(false);
                    setCuerpoModalMensajes({
                        ...cuerpoModalMensajes,
                        tituloModal: "informacion",
                        textoModal: data["data"]["signup"]["errors"][0]["messages"],
                    });
                    setOpenModalMensajes(true);
                    setNombres("");
                    setCorreo("");
                    setNacionalidad("");
                    setMovil("");
                    setContrasenna("");
                    setConfirmarContrasenna("");
                    setBoletin(false);
                    return;
                } else {
                    setLoading(false);
                    if (data["data"]["signup"]["errors"] === "" || data["data"]["signup"]["errors"] === null) {
                        setCuerpoModalMensajes({
                            ...cuerpoModalMensajes,
                            tituloModal: "informacion",
                            textoModal: <FormattedMessage id="validacion_registrarse_nueve" />,
                        });
                        setOpenModalMensajes(true);
                        setNombres("");
                        setCorreo("");
                        setNacionalidad("");
                        setMovil("");
                        setContrasenna("");
                        setConfirmarContrasenna("");
                        setBoletin(false);
                        return;
                    }
                }
            });
    };

    const iniciarsesion = () => {
        dispatch({ type: "DRAWER_OPERATION_REGISTER", status: false });
        dispatch({ type: "DRAWER_OPERATION_LOGIN", status: true });
    };

    const handleClickShowModalNacionalidad = () => {
        dispatch({ type: "OPEN_DIALOG_NACIONALIDAD", data: true });
    };

    const handleClickClose = () => {
        dispatch({ type: "DRAWER_OPERATION_REGISTER", status: false });
    };

    let textoNombres = intl.formatMessage({ id: "nombre_apellidos" }).toString();
    let textoCorreo = intl.formatMessage({ id: "correo" }).toString();
    let textoNacionalidad = intl.formatMessage({ id: "nacionalidad" }).toString();
    let textoTelefono = intl.formatMessage({ id: "telefono_movil" }).toString();
    let textoContrasena = intl.formatMessage({ id: "pass" }).toString();
    let textoConfirmarContrasena = intl.formatMessage({ id: "confirmar_contraseña" }).toString();
    let textoCampos = intl.formatMessage({ id: "campos_obligatorios" }).toString();
    let textoRecibirBoletin = intl.formatMessage({ id: "recibir_boletin" }).toString();
    let textoTerminos1 = intl.formatMessage({ id: "terminos1" }).toString();
    let textoTerminos2 = intl.formatMessage({ id: "terminos2" }).toString();
    let textoTerminos3 = intl.formatMessage({ id: "terminos3" }).toString();
    let textoTerminos4 = intl.formatMessage({ id: "terminos4" }).toString();
    let textoTerminos5 = intl.formatMessage({ id: "terminos5" }).toString();
    let textoRegistrarse = intl.formatMessage({ id: "registrarse" }).toString();
    let textoTienesCuenta = intl.formatMessage({ id: "ya_tienes_cuenta" }).toString();
    let textoIniciarSesion = intl.formatMessage({ id: "inicia_sesion" }).toString();

    //-------------------------------------------------------------------------------
    //--------------------------------VISTA------------------------------------------
    //-------------------------------------------------------------------------------
    useEffect(() => {
        if (selector.user.nacionalidad_seleccionada !== nacionalidad) {
            setNacionalidad(getNacionalidad(selector.user.nacionalidad_seleccionada));
            setNacionalidadId(selector.user.nacionalidad_seleccionada);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selector.user.nacionalidad_seleccionada]);

    useEffect(() => {
        callApiCountries();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <ThemeProvider theme={theme}>
                <Drawer
                    className={classes.drawer}
                    variant="temporary"
                    anchor="right"
                    open={selector.user.open_drawer_register}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    onEscapeKeyDown={handleClickClose}
                    onBackdropClick={handleClickClose}
                >
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={12} md={12} className={classes.gridItem}>
                            <div className={clsx(imageSize, classes.paperContainer)}>
                                <HeaderRegister namePage={<FormattedMessage id="registro" />} />
                            </div>
                            <Grid container style={{ textAlign: "center", marginTop: "3%" }}>
                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControl variant="outlined" className={classes.FormControl}>
                                        <InputLabel htmlFor="nombreApellidos" required>
                                            {textoNombres}
                                        </InputLabel>
                                        <OutlinedInput
                                            id="nombreApellidos"
                                            label={textoNombres}
                                            value={nombres}
                                            onChange={(e) => onChangeNombre(e)}
                                            inputProps={{
                                                maxLength: 60,
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControl variant="outlined" className={classes.FormControl}>
                                        <InputLabel htmlFor="correoElectronico" required>
                                            {textoCorreo}
                                        </InputLabel>
                                        <OutlinedInput
                                            id="correoElectronico"
                                            label={textoCorreo}
                                            value={correo}
                                            onChange={(e) => onChangeCorreo(e)}
                                            inputProps={{
                                                maxLength: 60,
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControl variant="outlined" className={clsx(classes.select, classes.FormControl)}>
                                        <TextField
                                            id="nacionalidad"
                                            required
                                            label={textoNacionalidad}
                                            value={nacionalidad}
                                            onChange={(e) => onChangeNacionalidad(e)}
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment>
                                                        <IconButton aria-label="toggle" onClick={handleClickShowModalNacionalidad} edge="end">
                                                            {<ExpandMoreIcon />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControl variant="outlined" className={classes.FormControl}>
                                        <InputLabel htmlFor="telefonoMovil">{textoTelefono}</InputLabel>
                                        <OutlinedInput
                                            id="telefonoMovil"
                                            label={textoTelefono}
                                            placeholder="Ej. +5354678098"
                                            value={movil}
                                            onChange={(e) => onChangeMovil(e)}
                                            inputProps={{
                                                maxLength: 20,
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControl className={classes.FormControl} variant="outlined">
                                        <InputLabel htmlFor="contrasenna" required>
                                            {textoContrasena}
                                        </InputLabel>
                                        <OutlinedInput
                                            id="contrasenna"
                                            type={showPassword ? "text" : "password"}
                                            value={contrasenna}
                                            onChange={(e) => onChangeContrasenna(e)}
                                            placeholder="+6 caracteres, 1 letra mayúscula"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            labelWidth={80}
                                            inputProps={{
                                                maxLength: 30,
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControl className={classes.FormControl} variant="outlined">
                                        <InputLabel htmlFor="contrasennaConfirmar" required>
                                            {textoConfirmarContrasena}
                                        </InputLabel>
                                        <OutlinedInput
                                            id="contrasennaConfirmar"
                                            type={showPassword ? "text" : "password"}
                                            value={confirmarContrasenna}
                                            onChange={(e) => onChangeConfirmarContrasenna(e)}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            labelWidth={160}
                                            inputProps={{
                                                maxLength: 30,
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} style={{ marginTop: "1rem", marginLeft: "-1.5rem" }}>
                                    <Typography className={classes.colorText}>
                                        <i style={{ color: "#A68A30" }}>*</i> {textoCampos}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} style={{ marginTop: "1rem", marginLeft: "1.5rem" }}>
                                    <FormControl>
                                        <FormControlLabel value="boletin" className={classes.colorText} control={<Radio onClick={onClicRecibirBoletin} checked={boletin} className={classes.colorText} />} label={textoRecibirBoletin} />
                                    </FormControl>
                                </Grid>
                                <Grid container style={{ textAlign: "center", width: "48%", marginLeft: "25%", marginTop: "1rem" }}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Typography className={classes.colorText} style={{ fontSize: "11pt" }}>
                                            {textoTerminos1}
                                            <i
                                                onClick={() => {
                                                    history.push("/legales/terminos_condiciones");
                                                    dispatch({ type: "DRAWER_OPERATION_REGISTER", status: false });
                                                }}
                                                className={classes.botonTexto}
                                            >
                                                {textoTerminos2}
                                            </i>
                                            {textoTerminos3}
                                            <i
                                                onClick={() => {
                                                    history.push("/legales/politica_privacidad");
                                                    dispatch({ type: "DRAWER_OPERATION_REGISTER", status: false });
                                                }}
                                                className={classes.botonTexto}
                                            >
                                                {textoTerminos4}
                                            </i>
                                            {textoTerminos5}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} style={{ marginTop: "1rem" }}>
                                    <Button size="large" className={classes.buttonRegistrarse} onClick={onClickRegistrarse}>
                                        {textoRegistrarse}
                                    </Button>
                                </Grid>
                                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                                    {loading && <CircularProgress disableShrink color="primary" size={30} />}
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} style={{ marginTop: "1rem" }}>
                                    <Typography className={classes.colorText} style={{ fontSize: "11pt" }}>
                                        {textoTienesCuenta}
                                        <Button onClick={iniciarsesion}>
                                            <i style={{ color: "#A68A30", fontWeight: "bold" }}>{textoIniciarSesion}</i>
                                        </Button>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Card style={{ backgroundColor: "#182C20" }}>
                                        <CardContent className={classes.cardContentHeader}></CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Drawer>
            </ThemeProvider>
            <ModalNacionalidad listado={listadoNacionalidades} />
            {/* Dialogo Mensaje */}
            <ModalMensajes openModal={openModalMensajes} setOpenModal={setOpenModalMensajes} cuerpoModal={cuerpoModalMensajes} />
        </div>
    );
}
